import { render, staticRenderFns } from "./AsociarEventosForm2.vue?vue&type=template&id=0bd09ebe&scoped=true&"
import script from "./AsociarEventosForm2.vue?vue&type=script&lang=ts&"
export * from "./AsociarEventosForm2.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarEventosForm2.vue?vue&type=style&index=0&id=0bd09ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd09ebe",
  null
  
)

export default component.exports